module.exports = __webpack_public_path__ + "static/media/stephane-kasriel.b3fdde02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/speakers/stephane-kasriel.jpg
// module id = 327
// module chunks = 0